module.exports = __webpack_public_path__ + "dimer/static/img/contactImg1.c27a63d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactImg1.jpg
// module id = bKxZ
// module chunks = 0